// modifer: styles/jss/nextjs-material-kit-pro/pages/componentsSections/sectionCards
import { section, container } from 'styles/jss/original/base';

import imageStyles from 'styles/jss/nextjs-material-kit-pro/imagesStyles.js';

const styles = {
  section: {
    ...section,
    padding: '0 0 40px',
    '@media (max-width: 992px)': {
      padding: '0 0 30px'
    },
    '@media (max-width: 640px)': {
      padding: '0 0 20px'
    }
  },
  container: {
    ...container,
    textAlign: 'center'
  },
  ...imageStyles,
  img: {
    maxWidth: '100%'
  },
  imgLoading: {
    width: '128px',
    padding: '100px 0'
  }
};

export default styles;
